import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
} from './club-logs.action';
import { ClubLogs } from './club-logs.model';

export interface ClubLogsRecordsState {
    listData: any[];
    singleData: ClubLogs;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: ClubLogsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
};


export const clubLogRecordReducer = createReducer(
    initialState,
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData: listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    on(resetState, () => initialState)  // Reset action handler
);